import { PlusCircleOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { Link } from "react-router-dom";
import { MdmTable } from "src/components/MdmTable";
import { PageLayout } from "src/components/PageLayout";
import { RtColumnsSettingsButton } from "src/components/ReactiveTable/components/RtColumnsSettings";
import { ToolBox2 } from "src/components/ToolBox2";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";

import { extensionsPageStore as pageStore } from "./extensionsPageStore";

export const ExtensionsPage: React.FC = observer(() => {
  const tools = (
    <>
      <RtColumnsSettingsButton store={pageStore.table} />
      <Link to={makeUrl(PageUrl.managementExtensionNew)}>
        <Button icon={<PlusCircleOutlined />} type="primary">
          Создать
        </Button>
      </Link>
    </>
  );

  return (
    <PageLayout title="Расширения">
      <ToolBox2 extraTools={tools} paddingMode="page">
        <MdmTable
          store={pageStore.table}
          columns={pageStore.columns}
          resizableColumns
          showSizeChanger
          rowClick={{
            type: "link",
            builder: ({ id }) =>
              makeUrl(PageUrl.managementExtensionCard, { id }),
          }}
        />
      </ToolBox2>
    </PageLayout>
  );
});
